import { render, staticRenderFns } from "./ImportLevels.vue?vue&type=template&id=1327e128&scoped=true&"
import script from "./ImportLevels.vue?vue&type=script&lang=js&"
export * from "./ImportLevels.vue?vue&type=script&lang=js&"
import style0 from "./ImportLevels.vue?vue&type=style&index=0&id=1327e128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327e128",
  null
  
)

export default component.exports